module.exports = __webpack_public_path__ + "static/media/location.d8450c0b.svg";